<span
    class="notification-container"
    (click)="toggleDropdown()"
>
    <mat-icon
        [matBadge]="getUnreadNotificationsCount()"
        [matBadgeHidden]="getUnreadNotificationsCount() === 0 || hideNotificationsBadge"
        matBadgeOverlap="true"
        matBadgeColor="warn"
        matBadgeSize="small"
    >notifications
    </mat-icon>
    <div
        class="notification-dropdown"
        *ngIf="isNotificationsDropdownOpen"
        [@fadeIn]
        (click)="$event.stopPropagation()"
    >
        <div class="notification-header-title">Notifications</div>
        <mat-form-field
            id="filterNotificationsFormField"
            class="filter-notifications w-100"
            floatLabel="never"
            appearance="fill"
        >
            <input
                matInput
                placeholder="Search"
                name="filterValue"
                (keyup)="updateFilteredNotifications($event.target.value)"
                [(ngModel)]="filterValue"
                style="font-size: 14px"
            >
            <mat-icon
                class="notifications-search-icon mat-icon-small"
                aria-hidden="false"
                aria-label="Notifications search icon"
                matSuffix
            >
                search
            </mat-icon>
        </mat-form-field>
        @for (notification of filteredNotifications; track notification.notificationId)
        {
            <mat-card class="notification-card">
                <div class="notification-header">
                    <div class="left">
                        <span class="notification-unread-marker" *ngIf="notification.state != 'READ'"></span>
                        <span class="notification-eventType">{{ notification.eventType }}</span>
                    </div>
                </div>
                <div class="notification-message">
                    <span>{{ notification.message }}</span>
                </div>
                <div class="notification-createdOn">
                    <span>{{ notification.createdOn | date: 'MMMM d, y, h:mm a' }}</span>
                </div>
            </mat-card>
        }
    </div>
</span>